import * as React from "react"
import { useState } from "react";
import { Profile } from "../models/profile-interface";

type TAuth = {
    isLoggedIn: boolean,
    setLoggedIn: Function,
    profile: Profile,
    setProfile: Function,
    mainScrollbarScrollTop: number,
    setMainScrollbarScrollTop: Function
}

const AuthContext = React.createContext<TAuth>({
    isLoggedIn: false,
    setLoggedIn: () => { },
    profile: null,
    setProfile: () => { },
    mainScrollbarScrollTop: 0,
    setMainScrollbarScrollTop: () => { }
});

enum Rights {
  CSAdmin = "CSAdmin",
  CSSignup = "CSSignup",
  CSDev = "CSDev",
  CSSuperUser = "CSSuperUser",
  CSAuthorizer = "CSAuthorizer"
};

function HasRight(rights: Rights[]) {
    const { profile } = React.useContext(AuthContext);
    if (profile && profile.rights) {
        return profile.rights.some(x => Object.values(rights).includes(x as any));
    }

    return false;
}

function ProfileHasRight(profile: Profile, rights: Rights[]) {
    if (profile && profile.rights) {
        return profile.rights.some(x => Object.values(rights).includes(x as any));
    }

    return false;
}

function AuthContextProvider({ children }) {
    const [isLoggedIn, setLoggedIn] = React.useState();
    const [profile, setProfile] = React.useState();
    const [mainScrollbarScrollTop, setMainScrollbarScrollTop] = useState<number>(null);

    return (
        <AuthContext.Provider value={{
            isLoggedIn,
            setLoggedIn,
            profile,
            setProfile,
            mainScrollbarScrollTop,
            setMainScrollbarScrollTop
        }}>
            {children}
        </AuthContext.Provider>
    )
}

export { AuthContextProvider, AuthContext, HasRight, ProfileHasRight, Rights }